import React from "react";
import format from "date-fns/format";
import getUnixTime from "date-fns/getUnixTime";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import { postApi, logErrors } from "../../api/getUser";
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import {
  ALBUM_BUCKET_NAME,
  BUCKET_REGION,
  IDENTITY_POOL_ID,
  NATEXT,
  s3Url,
} from "../constants";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import enUS from "date-fns/locale/en-US";
import enGB from "date-fns/locale/en-GB";
import enIN from "date-fns/locale/en-IN";
import enAU from "date-fns/locale/en-AU";
import enCA from "date-fns/locale/en-CA";
import { useTranslation } from "react-i18next";

let allLocales;
import("date-fns/locale").then((locales) => {
  allLocales = locales;
});

const ligthTheme = {
  backgroundColor: "white",
  color: "#646777",
};

const darkTheme = {
  backgroundColor: "#2e2c34",
  color: "#dddddd",
};

export const themes = {
  ligthTheme,
  darkTheme,
};

export const emailPatternExisitng =
  /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/;

// export const emailPattern =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const emailPattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

export const urlPattern =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)/;

export const toPercent = (decimal, fixed = 0) => `${decimal.toFixed(fixed)}%`;

export const firstLetterToUpperCase = (str) => {
  if (!str) return "";

  const firstLetterUpperCase = str[0].toUpperCase();
  return `${firstLetterUpperCase}${str.slice(1)}`;
};

export const getAdvancedFilterColumnName = (screen) => {
  if (screen.includes("fillups")) {
    return "fillups";
  }
  if (screen.includes("services")) {
    return "service";
  }
  if (screen.includes("expenses")) {
    return "expense";
  }
  if (screen.includes("trips")) {
    return "trips";
  } else if (
    screen.includes("maintenancereminders")
    //|| screen.includes("renewals")
  ) {
    return "maintenancereminders";
  } else if (screen.includes("documentrenewals")) {
    return "documentrenewals";
  } else if (screen.includes("renewals")) {
    return "renewals";
  } else if (screen.includes("inspectionscheduling")) {
    return "inspectionScheduling";
  } else if (screen.includes("inspectionsubmissions")) {
    return "inspectionsubmissions";
  } else if (screen.includes("workorders")) {
    return "workorders";
  } else if (screen.includes("parts")) {
    return "parts";
  } else if (screen.includes("usage")) {
    return "usage";
  } else if (screen.includes("vehicles")) {
    return "vehicles";
  } else if (screen.includes("equipment")) {
    return "equipment";
  } else {
    return screen;
  }
};

export const getScreenName = (page) => {
  let screenName = "";
  if (page.includes("fillups")) {
    screenName = "fillups";
  }
  if (page.includes("services")) {
    screenName = "service";
  }
  if (page.includes("expenses")) {
    screenName = "expense";
  }
  if (page.includes("trips")) {
    screenName = "trips";
  }
  if (page.includes("inspectionsubmissions")) {
    screenName = "inspectionsubmissions";
  }
  if (page.includes("inspectionscheduling")) {
    screenName = "inspectionschedules";
  }
  if (page.includes("inspectionforms")) {
    return "inspectionforms";
  }
  if (page.includes("inspectiontasks")) {
    return "inspectiontasks";
  }
  if (page.includes("maintenancereminders")) {
    return "maintenancereminders";
  }
  if (page.includes("documentrenewals")) {
    return "documentrenewals";
  }
  if (page.includes("renewals")) {
    return "renewals";
  }
  if (page.includes("issues")) {
    return "issues";
  }
  if (page.includes("workorders")) {
    return "work_order";
  }
  if (page.includes("servicetasks")) {
    return "servicetasks";
  }
  if (page.includes("expensetasks")) {
    return "expensetasks";
  }
  if (page.includes("dailymileage")) {
    return "dailymileage";
  }
  if (page.includes("vehicles")) {
    return "vehicles";
  }
  if (page.includes("users")) {
    return "users";
  }
  if (page.includes("groups")) {
    return "groups";
  }
  if (page.includes("dailytimesheet")) {
    return "dailytimesheet";
  }
  if (page.includes("faultcodes")) {
    return "faultcodes";
  }
  if (page.includes("parts")) {
    return "parts";
  }
  if (page.includes("usage")) {
    return "usage";
  }
  if (page.includes("equipment")) {
    return "equipment";
  }

  return screenName;
};

export const getScreenNameForImport = (page) => {
  let screenName = "";
  if (page.includes("fillups")) {
    screenName = "fillups";
  } else if (page.includes("services")) {
    screenName = "service";
  }
  if (page.includes("expenses")) {
    screenName = "expense";
  }
  if (page.includes("trips")) {
    screenName = "trips";
  }
  if (page.includes("inspectionsubmissions")) {
    screenName = "inspectionsubmissions";
  }
  if (page.includes("inspectionscheduling")) {
    screenName = "inspectionschedules";
  }
  if (page.includes("inspectionforms")) {
    return "inspectionforms";
  }
  if (page.includes("inspectiontasks")) {
    return "inspectiontasks";
  }
  if (page.includes("maintenancereminders")) {
    return "maintenancereminders";
  }
  if (page.includes("renewals")) {
    return "renewals";
  }
  if (page.includes("issues")) {
    return "issues";
  }
  if (page.includes("workorders")) {
    return "work_orders";
  }
  if (page.includes("servicetasks")) {
    return "servicetasks";
  }
  if (page.includes("expensetasks")) {
    return "expensetasks";
  }
  if (page.includes("dailymileage")) {
    return "dailymileage";
  }
  if (page.includes("vehicles")) {
    return "vehicles";
  }
  if (page.includes("users")) {
    return "users";
  }
  if (page.includes("inspectiontasks")) {
    return "inspectiontasks";
  }
  if (page.includes("equipment")) {
    return "equipment";
  }
  return screenName;
};

export const getColOrderQuery = (screen) => {
  let columnOrderQuery = "";
  if (screen === "fillups") {
    columnOrderQuery = "getfillupsorder";
  } else if (screen?.includes("services/services")) {
    columnOrderQuery = "getserviceorder";
  } else if (screen?.includes("expenses/expenses")) {
    columnOrderQuery = "getexpenseorder";
  } else if (screen === "trips") {
    columnOrderQuery = "gettripsorder";
  } else if (screen.includes("issues")) {
    columnOrderQuery = "getissuesorder";
  } else if (screen.includes("workorders")) {
    columnOrderQuery = "getwoorder";
  }
  return columnOrderQuery;
};

export const getDeleteQuery = (page) => {
  let deleteQuery = "";
  if (page.includes("fillups")) {
    deleteQuery = "fillups";
  } else if (page.includes("services")) {
    deleteQuery = "service";
  } else if (page.includes("expenses")) {
    deleteQuery = "expense";
  } else if (page.includes("trips")) {
    deleteQuery = "trips";
  } else if (page.includes("inspectionsubmissions")) {
    deleteQuery = "deleteInspectionsubmissions";
  } else if (page.includes("inspectionscheduling")) {
    return "deleteInspectionschedules";
  } else if (page.includes("inspectionforms")) {
    return "deleteInspectionforms";
  } else if (page.includes("inspectiontasks")) {
    return "deleteInspectiontasks";
  } else if (page.includes("maintenancereminders")) {
    return "deleteMaintenancereminders";
  } else if (page.includes("renewals")) {
    return "deleteRenewals";
  }
  return deleteQuery;
};

export const convertToTextDate = (date) => {
  return date.toLocaleDateString(navigator.language, {
    day: "numeric",
    year: "numeric",
    month: "short",
  });
};

export const convertToFilterDate = (date) => {
  return date.toLocaleDateString(navigator.language, {
    day: "numeric",
    year: "2-digit",
    month: "2-digit",
  });
};

export const convertToDisplayDate = (date) => {
  return date.toLocaleDateString(navigator.language, {
    day: "numeric",
    year: "numeric",
    month: "short",
    weekday: "short",
  });
};

export const convertToDisplayTime = (date) => {
  return date.toLocaleString(navigator.language, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getTimestamp = (id, index) => {
  return `${id}_${Math.floor(Math.random() * Date.now() * 10)}`;
};

export const getSingleDeleteQuery = (page) => {
  if (page.includes("fillups")) {
    return "fillups";
  } else if (page.includes("services")) {
    return "service";
  } else if (page.includes("expenses")) {
    return "expense";
  } else if (page.includes("trips")) {
    return "trips";
  } else if (page.includes("inspectionsubmissions")) {
    return "deleteinspectionsubmission";
  } else if (page.includes("inspectionscheduling")) {
    return "deleteInspectionschedules";
  } else if (page.includes("inspectionforms")) {
    return "deleteInspectionforms";
  } else if (page.includes("inspectiontasks")) {
    return "deleteInspectiontasks";
  } else if (page.includes("maintenancereminders")) {
    return "deleteMaintenancereminders";
  } else if (page.includes("renewals")) {
    return "deleteRenewals";
  }
};

export const getInitialStartTime = (date = new Date()) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  let hr = hours;
  let min = minutes;
  if (hours < 10) {
    hr = "0" + hr;
  }
  if (minutes < 10) {
    min = "0" + min;
  }
  return `${hr}:${min}`;
};

export function isObjEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export const handleNegative = (e) => {
  if (e.code === "Minus") {
    e.preventDefault();
  }
};

export const handleNumberInputOnWheelPreventChange = (e) => {
  // Prevent the input value change
  e.target.blur();

  // Prevent the page/container scrolling
  //e.stopPropagation();

  // Refocus immediately, on the next tick (after the current
  //function is done)
  // setTimeout(() => {
  //   e.target.focus();
  // }, 0);
};

export const getDisplayDate = (dateInSeconds) => {
  return format(new Date(dateInSeconds * 1000), "PP", {
    locale: getLocale(),
  }); //"dd-MMM-yyyy"
};

export const getDisplayTime = (dateInSeconds) => {
  return format(new Date(dateInSeconds * 1000), "h:mm a");
};

export const getDisplayDateWithTime = (dateInSeconds) => {
  return format(new Date(dateInSeconds * 1000), "PPp", { locale: getLocale() });
};

const getLocale = () => {
  const locale = navigator.language.replace("-", "");
  const rootLocale = locale.substring(0, 2);

  return allLocales ? allLocales[locale] || allLocales[rootLocale] : enIN;
};

export const getDateWithTime = (dateInMS, time) => {
  let dateWithTime = new Date(dateInMS);
  let [hours, minutes] = time?.split(":");
  if (hours < 10) {
    hours = hours[1];
  }

  if (minutes < 10) {
    minutes = minutes[1];
  }
  //let dateWithTime = "";
  dateWithTime = setHours(dateWithTime, hours);
  dateWithTime = setMinutes(dateWithTime, minutes);
  return getUnixTime(dateWithTime);
};

export const getImgString = (imgArr, rowId, userId, orgId, screenName) => {
  let imgsToS3 = [];

  let imgString = "";

  imgArr?.forEach((img, i) => {
    if (img?.hasOwnProperty("existing")) {
      imgString += `${img?.imgName}:::`;
    } else {
      if (img.file) {
        const extension = img?.file?.name.split(".").pop();
        const imgName = `${getTimestamp(userId, i)}.${extension}`;
        const key = `image_data/org_${orgId}/${screenName}/${imgName}`;

        imgString += `${imgName}:::`;

        imgsToS3.push({
          ...img,
          key: key,
        });
        // return {
        //   ...img,
        //   key: key,
        // };
      }
    }
  });
  imgString = imgString.slice(0, imgString.length - 3);

  return { imgString, imgsToS3 };
};

//For Array containing obj
export function checkForDuplicateObj(array, keyName) {
  return new Set(array.map((item) => item[keyName])).size !== array.length;
}

//For primitive arr
export function checkForDuplicates(array) {
  const seenValues = new Set();

  for (let value of array) {
    if (seenValues.has(value)) {
      return true;
    }
    seenValues.add(value);
  }

  return false;
}

export const getDistanceFactor = (vehicleDistanceUnit, orgDistanceUnit) => {
  let distanceFactor = 1;

  if (vehicleDistanceUnit == "Kilometers" && orgDistanceUnit == "Miles") {
    distanceFactor = 0.621;
  }
  //if vehicle PM is set to miles and org dist is km
  else if (vehicleDistanceUnit == "Miles" && orgDistanceUnit == "Kilometers") {
    distanceFactor = 1.609;
  }
  return distanceFactor;
};

export function getDistanceFactorforOdo(vehicleDistanceUnit, orgDistanceUnit) {
  let distanceFactor = 1;

  //if vehicle PM is set to km and org dist is miles
  if (vehicleDistanceUnit == "Kilometers" && orgDistanceUnit == "Miles") {
    distanceFactor = 0.621;
  }
  //if vehicle PM is set to miles and org dist is km
  else if (vehicleDistanceUnit == "Miles" && orgDistanceUnit == "Kilometers") {
    distanceFactor = 1.609;
  }
  return distanceFactor;
}

export const getOdoUnit = (distanceUnit) => {
  if (distanceUnit === "Kilometers") {
    return "Km";
  } else if (distanceUnit === "Miles") {
    return "Mi";
  } else if (distanceUnit === "Hours") {
    return "Hr";
  }
};

export const getDistanceUnit = (distanceUnit) => {
  if (distanceUnit === "Kilometers") {
    return "Km";
  } else if (distanceUnit === "Miles") {
    return "Mi";
  } else if (distanceUnit === "Hours") {
    return "Hr";
  }
};

export const uploadDocsToS3 = async (uploadToS3Arr) => {
  try {
    console.log("uploadToS3Arr", uploadToS3Arr);
    const client = new S3Client({
      region: "us-east-2",
      credentials: fromCognitoIdentityPool({
        identityPoolId: IDENTITY_POOL_ID,
        client: new CognitoIdentityClient({ region: BUCKET_REGION }),
      }),
      apiVersion: "2006-03-01",
    });

    const statusCodeArr = [];
    for (let i = 0; i < uploadToS3Arr.length; i++) {
      let currentImg = uploadToS3Arr[i];
      console.log("current doc", currentImg);
      const command = new PutObjectCommand({
        Bucket: ALBUM_BUCKET_NAME,
        Key: currentImg.key,
        Body: currentImg.file,
        ContentDisposition: "",
        ContentType: currentImg.file.type,
        //ACL: "public-read",
      });
      const response = await client.send(command);
      console.log("response", response);
      const statusCode = response.$metadata.httpStatusCode;
      statusCodeArr.push(statusCode);
      if (statusCodeArr.length === uploadToS3Arr.length) {
        const allImgsUploaded = statusCodeArr.every((code) => code === 200);
        console.log("allImgsUploaded", allImgsUploaded);
        return allImgsUploaded;
      }
    }
  } catch (e) {
    const errLogData = {
      url: `s3://${ALBUM_BUCKET_NAME}`,
      method_type: "PUT",
      error: JSON.stringify({
        message: e?.message,
        name: e?.name,
        fault: e?.$fault,
        httpStatusCode: e?.$metadata?.httpStatusCode,
        requestId: e?.$metadata?.requestId,
        extendedRequestId: e?.$metadata?.extendedRequestId,
        attempts: e?.$metadata?.attempts,
      }),
      request: JSON.stringify(uploadToS3Arr.map((img) => img.key)),
      placeholder: e?.stack ?? "",
    };
    await logErrors(errLogData);
    return e;
  }
};

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load image"));
    };
    img.src = url;
  });

const canvasToBlob = (canvas, mimeType, quality) =>
  new Promise((resolve) => canvas.toBlob(resolve, mimeType, quality));

/**
 * Compresses an image file client-side using canvas.
 * Resizes to fit within maxDimension (preserving aspect ratio)
 * and re-encodes in the original format at the given quality.
 */
// const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const compressImage = async (
  file,
  { maxDimension = 800, quality = 0.7 } = {},
) => {
  if (!file?.type.startsWith("image/")) return file;

  // TODO: Uncomment when there's a proper UI to show the error
  // if (file.size > MAX_FILE_SIZE) {
  //   throw new Error(`File size exceeds ${MAX_FILE_SIZE / (1024 * 1024)}MB limit`);
  // }

  try {
    const img = await loadImage(file);
    let { width, height } = img;

    if (
      width <= maxDimension &&
      height <= maxDimension &&
      file.size <= 200 * 1024
    ) {
      return file;
    }

    if (width > maxDimension || height > maxDimension) {
      const ratio = Math.min(maxDimension / width, maxDimension / height);
      width = Math.round(width * ratio);
      height = Math.round(height * ratio);
    }

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(img, 0, 0, width, height);

    const blob = await canvasToBlob(canvas, file.type, quality);

    if (!blob) return file;

    return new File([blob], file.name, {
      type: file.type,
      lastModified: Date.now(),
    });
  } catch {
    return file;
  }
};

export function getDistanceFactorForEff(orgDistanceUnit, orgConsumptionUnit) {
  let distanceFactor = 1;
  //check the consumption unit and the distance unit and volume unit and accordingly set the distance and volume factors
  //Get the set units
  //let orgDistanceUnit = store;
  //let orgConsumptionUnit = $("#org_consumption").val();
  //set the distance factor
  //set distance factor if distance is in km but consumption is in miles
  if (
    orgConsumptionUnit.substring(0, 1) == "m" &&
    orgDistanceUnit == "Kilometers"
  ) {
    distanceFactor = 0.621;
  }
  //set distance factor if distance is in miles but consumption is in km
  else if (
    orgConsumptionUnit.substring(0, 1) != "m" &&
    orgDistanceUnit == "Miles"
  ) {
    distanceFactor = 1.609;
  }
  //set the volume factor
  return distanceFactor;
}

//function to set volume factor for eff
export function getVolumeFactorForEff(orgVolumeUnit, orgConsumptionUnit) {
  let volumeFactor = 1;
  //check the consumption unit and the distance unit and volume unit and accordingly set the distance and volume factors
  //Get the set units
  // var orgVolumeUnit = $("#org_volume").val();
  // var orgConsumptionUnit = $("#org_consumption").val();
  //set the volume factor
  //set volume factor if consumption is in gallons(US)
  if (orgConsumptionUnit.includes("g (US)")) {
    if (orgVolumeUnit == "Liters") {
      volumeFactor = 0.264;
    } else if (orgVolumeUnit == "Gallons (UK)") {
      volumeFactor = 1.201;
    }
  }
  //set volume factor if consumption is in gallons(UK)
  else if (orgConsumptionUnit.includes("g (UK)")) {
    if (orgVolumeUnit == "Liters") {
      volumeFactor = 0.22;
    } else if (orgVolumeUnit == "Gallons (US)") {
      volumeFactor = 0.833;
    }
  }
  //set volume factor if consumption is in litres
  else {
    if (orgVolumeUnit == "Gallons (UK)") {
      volumeFactor = 4.546;
    } else if (orgVolumeUnit == "Gallons (US)") {
      volumeFactor = 3.785;
    }
  }
  return volumeFactor;
}

export const getVolumeFactor = (userVolumeUnit, orgVolumeUnit) => {
  let volumeFactor = 1;
  //set the volume factor
  if (userVolumeUnit == "Gallons (US)") {
    if (orgVolumeUnit == "Liters") {
      volumeFactor = 3.785;
    } else if (orgVolumeUnit == "Gallons (UK)") {
      volumeFactor = 0.833;
    }
  }
  //set volume factor if consumption is in gallons(UK)
  else if (userVolumeUnit == "Gallons (UK)") {
    if (orgVolumeUnit == "Liters") {
      volumeFactor = 4.546;
    } else if (orgVolumeUnit == "Gallons (US)") {
      volumeFactor = 1.201;
    }
  }
  //set volume factor if consumption is in litres
  if (userVolumeUnit == "Liters") {
    if (orgVolumeUnit == "Gallons (US)") {
      volumeFactor = 0.264;
    } else if (orgVolumeUnit == "Gallons (UK)") {
      volumeFactor = 0.22;
    }
  }
  return volumeFactor;
};

export const getTimeInHoursAndMinutes = (milliseconds) => {
  const hours = Math.floor(milliseconds / 3600000);
  const minutes = Math.floor((milliseconds % 3600000) / 60000);
  //const seconds = Math.floor(((milliseconds % 360000) % 60000) / 1000);
  return `${hours}:${minutes}`;
};

export const daysHoursMinutes = (timeInSec) => {
  let t = timeInSec;
  let cd = 24 * 60 * 60,
    ch = 60 * 60,
    d = Math.floor(t / cd),
    h = Math.floor((t - d * cd) / ch),
    m = Math.round((t - d * cd - h * ch) / 60);

  if (m === 60) {
    h++;
    m = 0;
  }
  if (h === 24) {
    d++;
    h = 0;
  }
  let display = "";

  if (d && d > 0) {
    display += d + "d ";
  }
  if (h) {
    display += h + "h ";
  }
  if (m) {
    display += m + "m";
  }

  if (!display) {
    display = NATEXT;
  }

  return { d, h, m, display };
};

export const dhmFormat = (timeInSec) => {
  let t = timeInSec;
  let cd = 24 * 60 * 60,
    ch = 60 * 60,
    d = Math.floor(t / cd),
    h = Math.floor((t - d * cd) / ch),
    m = Math.round((t - d * cd - h * ch) / 60);

  if (m === 60) {
    h++;
    m = 0;
  }
  if (h === 24) {
    d++;
    h = 0;
  }
  let display = "";

  if (d && d > 0) {
    display += formatNumber(d) + "d ";
  }
  if (h) {
    display += h + "h ";
  }
  if (m) {
    display += m + "m";
  }

  if (!display) {
    display = NATEXT;
  }

  return { d, h, m, display };
};

export const generateGroupsTreeArr = (groups) => {
  let items = [];
  groups.forEach((g) => {
    const level = !g.level ? 1 : g.level;
    let item = {};
    if (!g.parent_group) {
      item.parentId = null;
    } else {
      item.parentId = g.parent_group;
    }

    item.children =
      g.groupNodes?.length > 0
        ? g.groupNodes.filter(
            (id) => groups.find((g) => g.group_id === id).level === level + 1,
          )
        : [];
    item.groupNodes = g.groupNodes;
    item.label = g.label;
    item.value = g.value;
    item.id = g.group_id;
    item.groupId = g.groupId;
    item.group_id = g.group_id;
    item.isParent = g.groupNodes?.length > 0;
    item.showChildren = false;
    item.level = !g.level ? 1 : g.level;
    //item.fetched = false;
    item.spread = false;
    //item.show = !g.parent_group
    items.push(item);
  });

  return items;
};

export const generateTreeArr = (items, id = null, link = "parent_group") => {
  return items
    .filter((item) => item[link] === id)
    .map((item) => ({
      ...item,
      children: generateTreeArr(items, item.group_id),
    }));
};

//This method is used to fetch the row id key name and subquerystring for a screen
export const getMultiDeleteInfo = (page) => {
  let rowId = "";
  let subQuery = "";
  // if (page.includes("fillups")) {
  //   subQuery = "FILLUPS";
  //   rowId = "fillup_id";
  // }
  if (page.includes("services")) {
    subQuery = "SERVICES";
    rowId = "service_id";
  }
  if (page.includes("expenses")) {
    subQuery = "EXPENSES";
    rowId = "expense_id";
  }
  if (page.includes("trips")) {
    subQuery = "TRIPS";
    rowId = "trip_id";
  }
  if (page.includes("inspectionsubmissions")) {
    subQuery = "INSPECTIONS";
    rowId = "inspection_id";
  }
  if (page.includes("inspectionscheduling")) {
    subQuery = "INSPECTION_SCHEDULE";
    rowId = "inspection_schedule_id";
  }
  if (page.includes("inspectionforms")) {
    subQuery = "INSPECTION_FORMS";
    rowId = "form_id";
  }
  if (page.includes("inspectiontasks")) {
    subQuery = "INSPECTION_TASKS";
    rowId = "task_id";
  }
  if (page.includes("maintenancereminders")) {
    subQuery = "REMINDERS_SERVICE";
    rowId = "reminder_id";
  }
  if (page.includes("renewals")) {
    subQuery = "REMINDERS_EXPENSE";
    rowId = "reminder_id";
  }
  if (page.includes("issues")) {
    subQuery = "ISSUES";
    rowId = "issue_id";
  }
  if (page.includes("workorders")) {
    subQuery = "WORK_ORDERS";
    rowId = "wo_id";
  }
  if (page.includes("servicetasks")) {
    subQuery = "SERVICE_TASKS";
    rowId = "service_task_id";
  }
  if (page.includes("expensetasks")) {
    subQuery = "EXPENSE_TASKS";
    rowId = "expense_task_id";
  }
  if (page.includes("dailymileage")) {
    subQuery = "STARTING_ENDING_MILEAGE";
    rowId = "_id";
  }

  if (page.includes("fillups")) {
    subQuery = "FILLUPS";
    rowId = "fillup_id";
  }

  if (page.includes("dailytimesheet")) {
    subQuery = "DAILY_TIMESHEET";
    rowId = "timesheet_img";
  }

  if (page.includes("parts")) {
    subQuery = "PARTS";
    rowId = "part_id";
  }

  return { rowId, subQuery };
};

export const getUserDocUrl = async (orgId, userId, docName, extensionArr) => {
  let extension = "";
  if (extensionArr[0].includes("png")) {
    extension = "png";
  }
  if (extensionArr[0].includes("jpg")) {
    extension = "jpg";
  }
  if (extensionArr[0].includes("jpeg")) {
    extension = "jpeg";
  }
  if (extensionArr[0].includes("jfif")) {
    extension = "jfif";
  }
  if (extensionArr[0].includes("pdf")) {
    extension = "pdf";
  }

  let url = `${s3Url}/org_${orgId}/user_${userId}/Documents/${docName}.${extension}`;
  const res = await fetch(url);
  console.log("res", res);
  if (res.status === 404) {
    url = `image_data/org_${orgId}/user_${userId}/Documents/${docName}.txt`;
    extension = "txt";
  }
  return { url, extension };
};

export const getVehDocUrl = async (orgId, vehId, imgName) => {
  let imageName = imgName;
  let extension = "";
  if (imageName?.includes("png")) {
    extension = "png";
  }
  if (imageName?.includes("jpg")) {
    extension = "jpg";
  }
  if (imageName?.includes("jpeg")) {
    extension = "jpeg";
  }
  if (imageName?.includes("jfif")) {
    extension = "jfif";
  }
  if (imageName?.includes("pdf")) {
    extension = "pdf";
  }
  let url = `${s3Url}/org_${orgId}/vehicle_${vehId}/vehicle_doc/${imgName}`;
  const res = await fetch(url);
  if (res.status !== 200) {
    imageName = imageName?.replace(/\s+/g, "");
    url = `${s3Url}/org_${orgId}/vehicle_${vehId}/vehicle_doc/${imageName}`;
    return { url, extension };
  } else {
    return { url, extension };
  }
};

export const getDateFnsLocale = () => {
  const locale = window.navigator.userLanguage || window.navigator.language;
  //console.log(locale);
  let dateFnsLocale = enIN;
  if (locale.includes("US")) {
    dateFnsLocale = enUS;
  }
  if (locale.includes("GB")) {
    dateFnsLocale = enGB;
  }
  if (locale.includes("AU")) {
    //import(enAU);
    dateFnsLocale = enAU;
  }
  if (locale.includes("CA")) {
    //import(enAU);
    dateFnsLocale = enCA;
  }
  return dateFnsLocale;
};

export const getVolumeUnit = (volume) => {
  //console.log("vol", volume);
  let volUnit = volume;
  if (volume === "Liters") {
    volUnit = "Ltr";
  }
  if (volume === "Gallons (UK)") {
    volUnit = "Gal (UK)";
  }
  if (volume === "Gallons (US)") {
    volUnit = "Gal (US)";
  }
  return volUnit;
};

export const odoValidation = async (
  odoFieldName,
  apiData,
  setError,
  setSaveBtnLoading,
  t,
  distanceFactor,
  inputOdo,
) => {
  //const { t } = useTranslation("common");
  const odoRes = await postApi(apiData, "commonNew");
  console.log("odoResponse", odoRes);
  if (odoRes.success) {
    return 1;
  }
  if (!odoRes.success) {
    let odoErrMsg = "";
    const checkFrom = apiData.check_from;
    let { odometer, screen_name, date } = odoRes;
    const odoConverted = (odometer / distanceFactor)?.toFixed(2);
    let dateInSec = Number(date);
    const displayDate =
      checkFrom === "starting_ending_mileage"
        ? getDisplayDate(dateInSec)
        : getDisplayDateWithTime(dateInSec);
    if (screen_name === "starting odo") {
      odoErrMsg = t("odo_val_err_msg_veh", { startingOdo: odoConverted });
    } else if (screen_name === "overriden odo") {
      odoErrMsg = t("odo_val_overridden_err_msg", {
        date: displayDate,
        odometer: odoConverted,
        inputOdo,
      });
    } else {
      const screenName = getScreenNameForOdoVal(screen_name, t);
      console.log("screenName", screenName);
      odoErrMsg = t("odo_val_err_msg", {
        date: displayDate,
        odometer: odoConverted,
        screenName,
        inputOdo,
      });
      //odoErrMsg = `One of your ${screen_name} records shows an odometer reading of ${odometer}, dated ${displayDate}`;
    }

    setError(
      odoFieldName,
      { type: "custom", message: odoErrMsg },
      { shouldFocus: true },
    );
    setSaveBtnLoading(false);
    return 0;
  }
};

export const sortItems = (prev, curr, columnId) => {
  if (
    prev.original[columnId]?.toLowerCase() >
    curr.original[columnId]?.toLowerCase()
  ) {
    return 1;
  } else if (
    prev.original[columnId]?.toLowerCase() <
    curr.original[columnId]?.toLowerCase()
  ) {
    return -1;
  } else {
    return 0;
  }
};

export const handleHighOdoErr = (e, lastOdo, setErr) => {
  const { value } = e.target;
  if (value && lastOdo && +value - +lastOdo > 1000) {
    setErr(true);
  } else {
    setErr(false);
  }
};

export const getHourlyVolumeFactorEff = (
  orgVolumeUnit,
  orgHourlyConsumptionUnit,
) => {
  let hourlyVolumeFactor = 1;
  //check the consumption unit and the distance unit and volume unit and accordingly set the distance and volume factors

  //set the volume factor
  //set volume factor if consumption is in gallons(US)
  if (orgHourlyConsumptionUnit.includes("G (US)/Hr")) {
    if (orgVolumeUnit == "Liters") {
      hourlyVolumeFactor = 0.264;
    } else if (orgVolumeUnit == "Gallons (UK)") {
      hourlyVolumeFactor = 1.201;
    }
  }
  //set volume factor if consumption is in gallons(UK)
  else if (orgHourlyConsumptionUnit.includes("G (UK)/Hr")) {
    if (orgVolumeUnit == "Liters") {
      hourlyVolumeFactor = 0.22;
    } else if (orgVolumeUnit == "Gallons (US)") {
      hourlyVolumeFactor = 0.833;
    }
  }
  //set volume factor if consumption is in litres
  else {
    if (orgVolumeUnit == "Gallons (UK)") {
      hourlyVolumeFactor = 4.546;
    } else if (orgVolumeUnit == "Gallons (US)") {
      hourlyVolumeFactor = 3.785;
    }
  }
  return hourlyVolumeFactor;
};

export const getListingDisplayDate = (dateInSec) => {
  return new Date(dateInSec * 1000).toLocaleDateString(navigator.language, {
    day: "numeric",
    year: "numeric",
    month: "short",
  });
};

export const getDisplayDateWithTimeNew = (dateInSec) => {
  return new Date(dateInSec * 1000).toLocaleDateString(navigator.language, {
    day: "numeric",
    year: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const debounce = (func) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 500);
  };
};

export const handleVehicleOnChange = async (
  vehicle,
  onChange,
  userKey,
  setValue,
  setUserOptions,
  userId,
  roleId,
  allUsers,
  isTechnician = false, //isTechnician is used to check if the user is a technician with allow_wo=0(update: all technicians regardless of allow_wo)
) => {
  onChange(vehicle);

  if (!isTechnician) {
    // No need to fetch users for technician(with allow_wo=0) as reported by will be disabled and already set to logged in tech
    const apiData = {
      veh_id: vehicle?.veh_id,
      querystring: "getvehicleoperators",
    };
    const res = await postApi(apiData, "commonNew");
    if (res.success) {
      const { user_data } = res;
      if (user_data?.length > 0) {
        let temp = user_data.map((u) => ({
          ...u,
          label: u.name,
          value: u.user_id,
          user_id: u.user_id,
        }));
        if (roleId === 1) {
          //Append the admins present in allUsers that are not present in user_data
          //make sure users are not repeated
          const admins = allUsers.filter((u) => u.role_id === 1);

          // Use Set for O(1) lookup instead of array includes O(n)
          const existingUserIds = new Set(temp.map((u) => u.user_id));
          const newAdmins = admins.filter(
            (admin) => !existingUserIds.has(admin.user_id),
          );

          // Add the new admins to temp with the same structure
          const adminOptions = newAdmins.map((admin) => ({
            ...admin,
            label: admin.name,
            value: admin.user_id,
            user_id: admin.user_id,
          }));

          temp = [...temp, ...adminOptions];
        }

        //Append technicians for role ids 1 and 2 for serviced by, expense by and reported by
        if (
          (roleId === 1 || roleId === 2) &&
          ["servicedBy", "expenseBy", "reportedBy"].includes(userKey)
        ) {
          const technicians = allUsers.filter((u) => u.role_id === 4);
          const existingUserIds = new Set(temp.map((u) => u.user_id));
          const newTechnicians = technicians.filter(
            (tech) => !existingUserIds.has(tech.user_id),
          );
          const technicianOptions = newTechnicians.map((tech) => ({
            ...tech,
            label: tech.name,
            value: tech.user_id,
            user_id: tech.user_id,
          }));
          temp = [...temp, ...technicianOptions];
        }

        if (userKey) {
          const defaultUser = temp.find((u) => u.user_id === userId);
          if (defaultUser) {
            setValue(userKey, defaultUser);
          } else {
            setValue(userKey, "");
          }
        }

        setUserOptions(temp);
      }
    }
  }
};

export const getEditUsers = async (
  vehicleId,
  userId,
  roleId,
  allUsers,
  module = "",
) => {
  const apiData = {
    querystring: "get_vehicle_operators_edit",
    veh_id: vehicleId,
    edit_user_id: userId,
  };
  const res = await postApi(apiData, "commonNew");
  let result = [];
  if (res.success) {
    const { user_data } = res;
    result = user_data.map((u) => ({
      ...u,
      label: u.name,
      value: u.user_id,
      user_id: u.user_id,
    }));
    if (roleId === 1) {
      //Append the admins present in allUsers that are not present in user_data
      const admins = allUsers.filter((u) => u.role_id === 1);
      const existingUserIds = new Set(result.map((u) => u.user_id));
      const newAdmins = admins.filter(
        (admin) => !existingUserIds.has(admin.user_id),
      );
      const adminOptions = newAdmins.map((admin) => ({
        ...admin,
        label: admin.name,
        value: admin.user_id,
        user_id: admin.user_id,
      }));
      result = [...result, ...adminOptions];
    }

    //Append technicians for role ids 1 and 2 for serviced by, expense by and reported by
    if (
      (roleId === 1 || roleId === 2) &&
      ["services", "expenses", "issues"].includes(module)
    ) {
      const technicians = allUsers.filter((u) => u.role_id === 4);
      const existingUserIds = new Set(result.map((u) => u.user_id));
      const newTechnicians = technicians.filter(
        (tech) => !existingUserIds.has(tech.user_id),
      );
      const technicianOptions = newTechnicians.map((tech) => ({
        ...tech,
        label: tech.name,
        value: tech.user_id,
        user_id: tech.user_id,
      }));
      result = [...result, ...technicianOptions];
    }
  }
  return result;
};

export const getTranslatedPMUnit = (unit, t) => {
  if (unit === "Kilometers") {
    return t("kilometers");
  }
  if (unit === "Miles") {
    return t("miles");
  }
  if (unit === "Hours") {
    return t("hours_const");
  }
};

export const getTranslatedFuelTypeUnit = (unit, t) => {
  if (unit === "Petrol") {
    return t("petrol_const");
  }
  if (unit === "Diesel") {
    return t("diesel_const");
  }
};

export const getTranslatedTransactionType = (transactionType, t) => {
  switch (transactionType) {
    case "Cash":
      return t("cash_const");
    case "Check":
      return t("check_const");
    case "Credit card":
      return t("credit_card_const");
    case "Debit card":
      return t("debit_card_const");
    case "Fuel card":
      return t("fuel_card_const");
  }
};

export const getTranslatedVolumeUnit = (volUnit, t) => {
  switch (volUnit) {
    case "Gallons (UK)":
      return t("gallons_uk");
    case "Gallons (US)":
      return t("gallons_us");
    case "Liters":
      return t("liters");
  }
};

export const downloadImage = async (imageSrc, ext = "jpg") => {
  console.log(imageSrc);
  const image = await fetch(imageSrc, {
    mode: "cors",
    cache: "no-cache",
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  });
  const imageBlog = await image.blob();
  const imageURL = URL.createObjectURL(imageBlog);

  const link = document.createElement("a");
  link.href = imageURL;
  const downloadDate = new Date();
  link.download = `Simply Fleet ${format(
    downloadDate,
    "yyyy-MM-dd",
  )} at ${format(downloadDate, "HH.mm")}.jpg`; //ext can be used if required
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getTranslatedReasonText = (reason, t) => {
  switch (reason) {
    case 0:
      return t("purchased");
    case 1:
      return t("consumed");
    case 2:
      return t("damaged");
    case 3:
      return t("stolen");
    case 4:
      return t("returned");
    case 5:
      return t("sold");
    case 6:
      return t("stock_recon");
  }
};

export const getScreenNameForOdoVal = (screenVal, t) => {
  const screenNameMapping = {
    fillup: t("fillups"),
    service: t("services"),
    expense: t("expenses"),
    trip: t("trips"),
    "daily mileage": t("se_mileage"),
    inspection: t("inspection_submissions"),
    issue: t("issues"),
    "work order": t("work_orders"),
  };
  return screenNameMapping[screenVal];
};

//To get file type from extension, used in getDocFileType
export const getFileType = (ext) => {
  const extensionLowerCase = ext?.toLocaleLowerCase();
  if (extensionLowerCase.includes("pdf")) {
    return "pdf";
  }
  if (
    extensionLowerCase.includes("image") ||
    extensionLowerCase.includes("img") ||
    extensionLowerCase.includes("png") ||
    extensionLowerCase.includes("jpeg") ||
    extensionLowerCase.includes("jpg") ||
    extensionLowerCase.includes("webp") ||
    extensionLowerCase.includes("jfif")
  ) {
    return "img";
  }

  if (extensionLowerCase.includes("csv")) {
    return "csv";
  }
};

//Used to get file type of doc
export const getDocFileType = (doc) => {
  let fileType = "";
  if (doc?.file) {
    fileType = getFileType(doc?.file?.type);
  } else if (doc?.extension) {
    if (doc.extension === "txt") {
      fileType = getFileType(doc?.type[0]);
    } else {
      fileType = getFileType(doc.extension);
    }
  } else {
    fileType = getFileType(doc?.url?.split(".").pop());
  }
  return fileType;
};

export const uploadDocToS3 = async (doc) => {
  try {
    const client = new S3Client({
      region: "us-east-2",
      credentials: fromCognitoIdentityPool({
        identityPoolId: IDENTITY_POOL_ID,
        client: new CognitoIdentityClient({ region: BUCKET_REGION }),
      }),
      apiVersion: "2006-03-01",
    });

    const statusCodeArr = [];
    const command = new PutObjectCommand({
      Bucket: ALBUM_BUCKET_NAME,
      Key: doc.key,
      Body: doc.file,
      ContentDisposition: "",
      ContentType: doc.file.type,
      //ACL: "public-read",
    });
    const response = await client.send(command);
    const statusCode = response.$metadata.httpStatusCode;
    return statusCode;
    //statusCodeArr.push(statusCode);
  } catch (err) {
    return err;
  }
};

export const getRoleName = (roleId, t) => {
  switch (roleId) {
    case 1:
      return t("admin");
    case 2:
      return t("manager");
    case 3:
      return t("operator");
    case 4:
      return t("technician");
  }
};

export function formatNumber(value, noOfDecimals = 0) {
  const num = parseFloat(value);
  if (isNaN(num)) return "";

  const locale = navigator.language || "en-US"; // fallback if not available

  if (noOfDecimals === 0) {
    return num.toLocaleString(locale);
  }
  if (noOfDecimals > 0) {
    return num.toLocaleString(locale, {
      minimumFractionDigits: noOfDecimals,
      maximumFractionDigits: noOfDecimals,
    });
  }
}

// Country Detection Functions
export const detectCountryByTimezone = (timezone, countriesOptions) => {
  const timezoneMap = {
    // United States
    "America/New_York": "United States",
    "America/Chicago": "United States",
    "America/Denver": "United States",
    "America/Los_Angeles": "United States",
    "America/Phoenix": "United States",
    "America/Anchorage": "United States",
    "America/Honolulu": "United States",
    "America/Detroit": "United States",
    "America/Indiana/Indianapolis": "United States",
    "America/Kentucky/Louisville": "United States",

    // Canada
    "America/Toronto": "Canada",
    "America/Vancouver": "Canada",
    "America/Montreal": "Canada",
    "America/Edmonton": "Canada",
    "America/Winnipeg": "Canada",
    "America/Halifax": "Canada",
    "America/St_Johns": "Canada",

    // United Kingdom & Ireland
    "Europe/London": "United Kingdom",
    "Europe/Dublin": "Ireland",
    "Europe/Belfast": "United Kingdom",

    // Europe
    "Europe/Paris": "France",
    "Europe/Berlin": "Germany",
    "Europe/Rome": "Italy",
    "Europe/Madrid": "Spain",
    "Europe/Amsterdam": "Netherlands",
    "Europe/Brussels": "Belgium",
    "Europe/Vienna": "Austria",
    "Europe/Zurich": "Switzerland",
    "Europe/Stockholm": "Sweden",
    "Europe/Oslo": "Norway",
    "Europe/Copenhagen": "Denmark",
    "Europe/Helsinki": "Finland",
    "Europe/Warsaw": "Poland",
    "Europe/Prague": "Czech Republic",
    "Europe/Budapest": "Hungary",
    "Europe/Bucharest": "Romania",
    "Europe/Sofia": "Bulgaria",
    "Europe/Athens": "Greece",
    "Europe/Lisbon": "Portugal",
    "Europe/Moscow": "Russia",
    "Europe/Kiev": "Ukraine",
    "Europe/Minsk": "Belarus",
    "Europe/Riga": "Latvia",
    "Europe/Tallinn": "Estonia",
    "Europe/Vilnius": "Lithuania",
    "Europe/Zagreb": "Croatia",
    "Europe/Ljubljana": "Slovenia",
    "Europe/Skopje": "Macedonia",
    "Europe/Sarajevo": "Bosnia and Herzegovina",
    "Europe/Belgrade": "Serbia",
    "Europe/Podgorica": "Montenegro",
    "Europe/Tirana": "Albania",
    "Europe/Istanbul": "Turkey",

    // Asia
    "Asia/Tokyo": "Japan",
    "Asia/Shanghai": "China",
    "Asia/Beijing": "China",
    "Asia/Seoul": "South Korea",
    "Asia/Pyongyang": "North Korea",
    "Asia/Hong_Kong": "Hong Kong",
    "Asia/Macau": "Macao",
    "Asia/Taipei": "Taiwan",
    "Asia/Singapore": "Singapore",
    "Asia/Bangkok": "Thailand",
    "Asia/Jakarta": "Indonesia",
    "Asia/Manila": "Philippines",
    "Asia/Kuala_Lumpur": "Malaysia",
    "Asia/Ho_Chi_Minh": "Vietnam",
    "Asia/Mumbai": "India",
    "Asia/Kolkata": "India",
    "Asia/Calcutta": "India",
    "Asia/Delhi": "India",
    "Asia/Chennai": "India",
    "Asia/Bangalore": "India",
    "Asia/Hyderabad": "India",
    "Asia/Pune": "India",
    "Asia/Ahmedabad": "India",
    "Asia/Jaipur": "India",
    "Asia/Lucknow": "India",
    "Asia/Kanpur": "India",
    "Asia/Nagpur": "India",
    "Asia/Indore": "India",
    "Asia/Bhopal": "India",
    "Asia/Ludhiana": "India",
    "Asia/Amritsar": "India",
    "Asia/Chandigarh": "India",
    "Asia/Goa": "India",
    "Asia/Thiruvananthapuram": "India",
    "Asia/Kochi": "India",
    "Asia/Coimbatore": "India",
    "Asia/Madurai": "India",
    "Asia/Vijayawada": "India",
    "Asia/Visakhapatnam": "India",
    "Asia/Rajkot": "India",
    "Asia/Surat": "India",
    "Asia/Vadodara": "India",
    "Asia/Nashik": "India",
    "Asia/Aurangabad": "India",
    "Asia/Solapur": "India",
    "Asia/Kolhapur": "India",
    "Asia/Sangli": "India",
    "Asia/Mysore": "India",
    "Asia/Mangalore": "India",
    "Asia/Hubli": "India",
    "Asia/Gulbarga": "India",
    "Asia/Belgaum": "India",
    "Asia/Bijapur": "India",
    "Asia/Shimoga": "India",
    "Asia/Tumkur": "India",
    "Asia/Kolar": "India",
    "Asia/Mandya": "India",
    "Asia/Hassan": "India",
    "Asia/Chitradurga": "India",
    "Asia/Davanagere": "India",
    "Asia/Bellary": "India",
    "Asia/Raichur": "India",
    "Asia/Bidar": "India",
    "Asia/Yadgir": "India",
    "Asia/Koppal": "India",
    "Asia/Gadag": "India",
    "Asia/Dharwad": "India",
    "Asia/Haveri": "India",
    "Asia/Udupi": "India",
    "Asia/Chikmagalur": "India",
    "Asia/Chamarajanagar": "India",
    "Asia/Kodagu": "India",
    "Asia/Chikkaballapur": "India",
    "Asia/Ramanagara": "India",
    "Asia/Chikkamagaluru": "India",
    "Asia/Dubai": "United Arab Emirates",
    "Asia/Riyadh": "Saudi Arabia",
    "Asia/Kuwait": "Kuwait",
    "Asia/Tehran": "Iran",
    "Asia/Karachi": "Pakistan",
    "Asia/Lahore": "Pakistan",
    "Asia/Islamabad": "Pakistan",
    "Asia/Dhaka": "Bangladesh",
    "Asia/Kathmandu": "Nepal",
    "Asia/Colombo": "Sri Lanka",
    "Asia/Kabul": "Afghanistan",
    "Asia/Tashkent": "Uzbekistan",
    "Asia/Almaty": "Kazakhstan",
    "Asia/Bishkek": "Kyrgyzstan",
    "Asia/Dushanbe": "Tajikistan",
    "Asia/Ashgabat": "Turkmenistan",
    "Asia/Yerevan": "Armenia",
    "Asia/Baku": "Azerbaijan",
    "Asia/Tbilisi": "Georgia",
    "Asia/Yekaterinburg": "Russia",
    "Asia/Novosibirsk": "Russia",
    "Asia/Vladivostok": "Russia",
    "Asia/Krasnoyarsk": "Russia",
    "Asia/Irkutsk": "Russia",
    "Asia/Omsk": "Russia",

    // Australia & Pacific
    "Australia/Sydney": "Australia",
    "Australia/Melbourne": "Australia",
    "Australia/Perth": "Australia",
    "Australia/Brisbane": "Australia",
    "Australia/Adelaide": "Australia",
    "Australia/Darwin": "Australia",
    "Australia/Hobart": "Australia",
    "Pacific/Auckland": "New Zealand",
    "Pacific/Fiji": "Fiji Islands",
    "Pacific/Guam": "Guam",
    "Pacific/Honolulu": "United States",
    "Pacific/Tahiti": "French Polynesia",

    // Africa
    "Africa/Cairo": "Egypt",
    "Africa/Johannesburg": "South Africa",
    "Africa/Cape_Town": "South Africa",
    "Africa/Lagos": "Nigeria",
    "Africa/Nairobi": "Kenya",
    "Africa/Casablanca": "Morocco",
    "Africa/Algiers": "Algeria",
    "Africa/Tunis": "Tunisia",
    "Africa/Tripoli": "Libya",
    "Africa/Khartoum": "Sudan",
    "Africa/Addis_Ababa": "Ethiopia",
    "Africa/Dar_es_Salaam": "Tanzania",
    "Africa/Kampala": "Uganda",
    "Africa/Kigali": "Rwanda",
    "Africa/Bujumbura": "Burundi",
    "Africa/Maputo": "Mozambique",
    "Africa/Harare": "Zimbabwe",
    "Africa/Lusaka": "Zambia",
    "Africa/Gaborone": "Botswana",
    "Africa/Windhoek": "Namibia",
    "Africa/Luanda": "Angola",
    "Africa/Kinshasa": "Congo",
    "Africa/Brazzaville": "Congo",
    "Africa/Douala": "Cameroon",
    "Africa/Abidjan": "Ivory Coast",
    "Africa/Accra": "Ghana",
    "Africa/Lome": "Togo",
    "Africa/Porto-Novo": "Benin",
    "Africa/Niamey": "Niger",
    "Africa/Bamako": "Mali",
    "Africa/Ouagadougou": "Burkina Faso",
    "Africa/Dakar": "Senegal",
    "Africa/Banjul": "Gambia",
    "Africa/Bissau": "Guinea-Bissau",
    "Africa/Conakry": "Guinea",
    "Africa/Freetown": "Sierra Leone",
    "Africa/Monrovia": "Liberia",
    "Africa/Malabo": "Equatorial Guinea",
    "Africa/Sao_Tome": "Sao Tome and Principe",
    "Africa/Mogadishu": "Somalia",
    "Africa/Djibouti": "Djibouti",
    "Africa/Asmara": "Eritrea",

    // South America
    "America/Sao_Paulo": "Brazil",
    "America/Rio_de_Janeiro": "Brazil",
    "America/Brasilia": "Brazil",
    "America/Manaus": "Brazil",
    "America/Fortaleza": "Brazil",
    "America/Recife": "Brazil",
    "America/Salvador": "Brazil",
    "America/Buenos_Aires": "Argentina",
    "America/Cordoba": "Argentina",
    "America/Mendoza": "Argentina",
    "America/Santiago": "Chile",
    "America/Lima": "Peru",
    "America/Bogota": "Colombia",
    "America/Medellin": "Colombia",
    "America/Caracas": "Venezuela",
    "America/Maracaibo": "Venezuela",
    "America/Mexico_City": "Mexico",
    "America/Cancun": "Mexico",
    "America/Merida": "Mexico",
    "America/Monterrey": "Mexico",
    "America/Tijuana": "Mexico",
    "America/Guatemala": "Guatemala",
    "America/Belize": "Belize",
    "America/Tegucigalpa": "Honduras",
    "America/Managua": "Nicaragua",
    "America/San_Jose": "Costa Rica",
    "America/Panama": "Panama",
    "America/Havana": "Cuba",
    "America/Jamaica": "Jamaica",
    "America/Port-au-Prince": "Haiti",
    "America/Santo_Domingo": "Dominican Republic",
    "America/Puerto_Rico": "Puerto Rico",
    "America/Guayaquil": "Ecuador",
    "America/Quito": "Ecuador",
    "America/La_Paz": "Bolivia",
    "America/Asuncion": "Paraguay",
    "America/Montevideo": "Uruguay",
    "America/Cayenne": "French Guiana",
    "America/Paramaribo": "Suriname",
    "America/Georgetown": "Guyana",
  };

  const countryName = timezoneMap[timezone];
  return countryName
    ? countriesOptions.find(
        (c) => c.label.toLowerCase() === countryName.toLowerCase(),
      )
    : null;
};

export const detectUserCountry = (countriesOptions) => {
  // 1. TIMEZONE DETECTION (Most Reliable - Always prioritize this)
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneCountry = detectCountryByTimezone(timezone, countriesOptions);
  if (timezoneCountry) {
    return timezoneCountry;
  }

  // 2. INTL LOCALE (Second Most Reliable)
  const intlOptions = Intl.DateTimeFormat().resolvedOptions();
  const intlCountryCode = intlOptions.locale.split("-")[1];

  if (intlCountryCode) {
    const foundCountry = countriesOptions.find(
      (c) => c.countryCode === intlCountryCode,
    );
    if (foundCountry) {
      return foundCountry;
    }
  }

  // 3. NAVIGATOR LANGUAGE (Least Reliable)
  const navLocale = window.navigator.language || window.navigator.userLanguage;
  const navCountryCode = navLocale.split(/[-_]/)[1];

  if (navCountryCode) {
    const foundCountry = countriesOptions.find(
      (c) => c.countryCode === navCountryCode,
    );
    if (foundCountry) {
      return foundCountry;
    }
  }

  // 4. LANGUAGE DEFAULTS (Fallback)
  const plainLanguage = navLocale.split(/[-_]/)[0];
  const languageDefaults = {
    en: "United States",
    es: "Spain",
    fr: "France",
    de: "Germany",
    it: "Italy",
    pt: "Brazil",
    ru: "Russia",
    ja: "Japan",
    ko: "South Korea",
    zh: "China",
  };

  const defaultCountry = languageDefaults[plainLanguage];
  if (defaultCountry) {
    const foundCountry = countriesOptions.find(
      (c) => c.label.toLowerCase() === defaultCountry.toLowerCase(),
    );
    if (foundCountry) {
      return foundCountry;
    }
  }

  // 5. FINAL FALLBACK
  return (
    countriesOptions.find((c) => c.label.toLowerCase() === "united states") ||
    countriesOptions[0]
  );
};

export const getDeclineErrorMessage = (decline_code, t, defaultKey) => {
  switch (decline_code) {
    case "insufficient_funds":
    case "card_not_supported":
    case "expired_card":
      return t("card_declined_error");

    case "incorrect_number":
    case "incorrect_cvc":
    case "invalid_expiry_month":
    case "invalid_expiry_year":
    case "incorrect_zip":
      return t("card_details_incorrect_error");

    case "payment_intent_authentication_failure":
      return t("payment_intent_authentication_failure");

    case "generic_decline":
      return t("generic_decline_error");

    default:
      return t(defaultKey);
  }
};

export const getAssetConditionOptions = (t) => [
    { value: 1, label: t("asset_condition_good"), color: "#22c55e" },
    { value: 2, label: t("asset_condition_fair"), color: "#eab308" },
    { value: 3, label: t("asset_condition_poor"), color: "#f97316" },
    { value: 4, label: t("asset_condition_unserviceable"), color: "#ef4444" },
  ];
